<template>
  <v-layout wrap class="hvf-browser-body">
    <v-flex xs12 short-control-toolbar-wrapper>
      <hvf-multi-exam-toolbar />
    </v-flex>
    <v-flex xs12 hvf-main-view-wrapper>
      <hvf-multi-exam-container />
    </v-flex>
  </v-layout>
</template>

<script>
import hvfMultiExamToolbar from "./HVFMultiExamToolbar";
import hvfMultiExamContainer from "./HVFMultiExamContainer";
export default {
  name: "hvfMultiviewContext",
  components: {hvfMultiExamToolbar, hvfMultiExamContainer}
}
</script>